import Vue from 'vue';
import Router from 'vue-router';
import Store from '@/store';
import helpers from '@/helpers';
import Auth from '@/services/Auth';
import Dom from '@/services/Dom';
import mediator from '@/mediator';
import Permissions from '@/services/Permissions';
import AcademicLevels from '@/components/routes/academicLevels/AcademicLevels.vue';
import AcademicLevelsList from '@/components/routes/academicLevels/List.vue';
import AcademicLevelsSummary from '@/components/routes/academicLevels/summary.vue';
import AcademicLevelsProgress from '@/components/routes/academicLevels/Progress.vue';
import AcademicLevelsGeneralProgress from '@/components/routes/academicLevels/GeneralProgress.vue';
import AcademicLevelsCategoriesProgress from '@/components/routes/academicLevels/CategoriesProgress.vue';
import AcademicLevelsCategoryProgress from '@/components/routes/academicLevels/CategoryProgress.vue';
import Languages from '@/components/routes/languages/Languages.vue';
import LanguagesList from '@/components/routes/languages/List.vue';
import LanguagesSummary from '@/components/routes/languages/Summary.vue';
import LanguagesProgress from '@/components/routes/languages/Progress.vue';
import LanguagesGeneralProgress from '@/components/routes/languages/GeneralProgress.vue';
import LanguagesCategoriesProgress from '@/components/routes/languages/CategoriesProgress.vue';
import LanguagesCategoryProgress from '@/components/routes/languages/CategoryProgress.vue';
import Login from '@/components/routes/Login';
import NoRoute from '@/components/routes/NoRoute';
import School from '@/components/routes/school/School.vue';
import SchoolSummary from '@/components/routes/school/Summary.vue';
import SchoolCategorySummary from '@/components/routes/school/CategorySummary.vue';
import SchoolProgress from '@/components/routes/school/Progress.vue';
import SchoolCategoriesProgress from '@/components/routes/school/CategoriesProgress.vue';
import SchoolCategoryProgress from '@/components/routes/school/CategoryProgress.vue';
import Schools from '@/components/routes/schools/Schools.vue';
import SchoolsList from '@/components/routes/schools/List.vue';
import Teachers from '@/components/routes/school/School.vue';
import TeachersList from '@/components/routes/teachers/List.vue';
import TeachersSummary from '@/components/routes/teachers/Summary.vue';
import TeachersProgress from '@/components/routes/teachers/Progress.vue';
import TeachersCategoriesProgress from '@/components/routes/teachers/CategoriesProgress.vue';
import TeachersCategoryProgress from '@/components/routes/teachers/CategoryProgress.vue';
import Admin from '@/components/routes/admin/Admin.vue';
import AdminSummary from '@/components/routes/admin/AdminSummary.vue';
import AdminSchools from '@/components/routes/admin/AdminSchools.vue';
import SchoolAllSyntheses from '@/components/routes/admin/SchoolAllSyntheses.vue';
import SchoolSyntheses from '@/components/routes/admin/SchoolSyntheses.vue';
import Syntheses from '@/components/routes/admin/Syntheses.vue';
import SynthesesReport from '@/components/routes/admin/SynthesesReport.vue';
import SynthesesDashboard from '@/components/routes/admin/SynthesesDashboard.vue';
import EvaluationDetail from '@/components/routes/admin/EvaluationDetail.vue';
import IssueDetail from '@/components/routes/admin/IssueDetail.vue';
import Issues from '@/components/routes/admin/Issues.vue';
import SchoolIssues from '@/components/routes/admin/SchoolIssues.vue';
import DiagnosticDetail from '@/components/routes/admin/DiagnosticDetail.vue';
import IndicatorDetail from '@/components/routes/admin/IndicatorDetail.vue';
import TrainingDetail from '@/components/routes/admin/TrainingDetail.vue';
import VisitClosureDetail from '@/components/routes/admin/VisitClosureDetail.vue';

Vue.use(Router);

const ANY_ROLE = '*';

const router = new Router({
	mode: 'history',
	scrollBehavior (to, from, savedPosition) {
		if (savedPosition) {
			return savedPosition;
		} else {
			return {x: 0, y: 0};
		}
	},
	routes: [
		{
			path: '/',
			redirect: '/coaching/school'
		},
		{
			path: '/coaching',
			redirect: '/coaching/school'
		},
		{
			path: '/coaching/school',
			component: School,
			meta: {allowedRoles: [ANY_ROLE]},
			children: [
				{
					path: '/',
					redirect: `summary`
				},
				{
					path: 'summary',
					component: SchoolSummary,
					beforeEnter: async function (to, from, next) {
						try {
							await mediator.hideContent();
							await mediator.coaching.getSchoolSummary();
							await Store.dispatch('activeMenu', to.path);
							next();
						} catch (error) {
							await mediator.showContent();
							next({
								path: `/login?error=${helpers.apiErrorMessages.getHumanErrorMessage(error)}`
							});
						}
					}
				},
				{
					path: 'summary/categories/:categoryId',
					component: SchoolCategorySummary,
					props: true,
					beforeEnter: async function (to, from, next) {
						try {
							await mediator.hideContent();
							await mediator.coaching.getSchoolSummary();
							await Store.dispatch('activeMenu', to.path);
							next();
						} catch (error) {
							await mediator.showContent();
							next({
								path: `/login?error=${helpers.apiErrorMessages.getHumanErrorMessage(error)}`
							});
						}
					}
				},
				{
					path: 'progress',
					component: SchoolProgress,
					beforeEnter: async function (to, from, next) {
						try {
							await mediator.hideContent();
							await mediator.coaching.getSchoolSummary();
							await mediator.coaching.getSchoolProgress();
							await Store.dispatch('activeMenu', to.path);
							next();
						} catch (error) {
							await mediator.showContent();
							next({
								path: `/login?error=${helpers.apiErrorMessages.getHumanErrorMessage(error)}`
							});
						}
					}
				},
				{
					path: 'progress/categories',
					component: SchoolCategoriesProgress,
					beforeEnter: async function (to, from, next) {
						try {
							await mediator.hideContent();
							await mediator.coaching.getSchoolSummary();
							await mediator.coaching.getSchoolProgress();
							await Store.dispatch('activeMenu', to.path);
							next();
						} catch (error) {
							await mediator.showContent();
							next({
								path: `/login?error=${helpers.apiErrorMessages.getHumanErrorMessage(error)}`
							});
						}
					}
				},
				{
					path: 'progress/categories/:categoryId',
					component: SchoolCategoryProgress,
					props: true,
					beforeEnter: async function (to, from, next) {
						try {
							await mediator.hideContent();
							await mediator.coaching.getSchoolSummary();
							await mediator.coaching.getSchoolProgress();
							await Store.dispatch('activeMenu', to.path);
							next();
						} catch (error) {
							await mediator.showContent();
							next({
								path: `/login?error=${helpers.apiErrorMessages.getHumanErrorMessage(error)}`
							});
						}
					}
				}
			]
		},
		{
			path: '/coaching/teachers',
			component: Teachers,
			meta: {allowedRoles: [ANY_ROLE]},
			children: [
				{
					path: '/',
					redirect: `list`
				},
				{
					path: 'list',
					component: TeachersList,
					beforeEnter: async function (to, from, next) {
						try {
							await mediator.hideContent();
							await mediator.coaching.getSchoolSummary();
							await mediator.coaching.getSchoolTeachersSummary();
							await Store.dispatch('activeMenu', to.path);
							next();
						} catch (error) {
							await mediator.showContent();
							next({
								path: `/login?error=${helpers.apiErrorMessages.getHumanErrorMessage(error)}`
							});
						}
					}
				},
				{
					path: 'summary/:teacherPersonUuid',
					component: TeachersSummary,
					props: true,
					beforeEnter: async function (to, from, next) {
						try {
							await mediator.hideContent();
							await mediator.coaching.getSchoolTeachersSummary();
							await mediator.coaching.getSchoolTeachersProgress();
							await Store.dispatch('activeMenu', to.path);
							next();
						} catch (error) {
							await mediator.showContent();
							next({
								path: `/login?error=${helpers.apiErrorMessages.getHumanErrorMessage(error)}`
							});
						}
					}
				},
				{
					path: 'progress/:teacherPersonUuid',
					component: TeachersProgress,
					props: true,
					beforeEnter: async function (to, from, next) {
						try {
							await mediator.hideContent();
							await mediator.coaching.getSchoolTeachersSummary();
							await mediator.coaching.getSchoolTeachersProgress();
							await Store.dispatch('activeMenu', to.path);
							next();
						} catch (error) {
							await mediator.showContent();
							next({
								path: `/login?error=${helpers.apiErrorMessages.getHumanErrorMessage(error)}`
							});
						}
					}
				},
				{
					path: 'progress/:teacherPersonUuid/categories',
					component: TeachersCategoriesProgress,
					props: true,
					beforeEnter: async function (to, from, next) {
						try {
							await mediator.hideContent();
							await mediator.coaching.getSchoolTeachersSummary();
							await mediator.coaching.getSchoolTeachersProgress();
							await Store.dispatch('activeMenu', to.path);
							next();
						} catch (error) {
							await mediator.showContent();
							next({
								path: `/login?error=${helpers.apiErrorMessages.getHumanErrorMessage(error)}`
							});
						}
					}
				},
				{
					path: 'progress/:teacherPersonUuid/categories/:categoryId',
					component: TeachersCategoryProgress,
					props: true,
					beforeEnter: async function (to, from, next) {
						try {
							await mediator.hideContent();
							await mediator.coaching.getSchoolTeachersSummary();
							await mediator.coaching.getSchoolTeachersProgress();
							await Store.dispatch('activeMenu', to.path);
							next();
						} catch (error) {
							await mediator.showContent();
							next({
								path: `/login?error=${helpers.apiErrorMessages.getHumanErrorMessage(error)}`
							});
						}
					}
				}
			]
		},
		{
			path: '/coaching/languages',
			component: Languages,
			meta: {allowedRoles: [ANY_ROLE]},
			children: [
				{
					path: '/',
					redirect: `list`
				},
				{
					path: 'list',
					component: LanguagesList,
					beforeEnter: async function (to, from, next) {
						try {
							await mediator.hideContent();
							await mediator.coaching.getSchoolSummary();
							await mediator.coaching.getSchoolLanguagesSummary();
							await Store.dispatch('activeMenu', to.path);
							next();
						} catch (error) {
							await mediator.showContent();
							next({
								path: `/login?error=${helpers.apiErrorMessages.getHumanErrorMessage(error)}`
							});
						}
					}
				},
				{
					path: 'summary/:isoCode',
					component: LanguagesSummary,
					props: true,
					beforeEnter: async function (to, from, next) {
						try {
							await mediator.hideContent();
							await mediator.coaching.getSchoolLanguagesSummary();
							await Store.dispatch('activeMenu', to.path);
							next();
						} catch (error) {
							await mediator.showContent();
							next({
								path: `/login?error=${helpers.apiErrorMessages.getHumanErrorMessage(error)}`
							});
						}
					}
				},
				{
					path: 'progress',
					component: LanguagesGeneralProgress,
					props: true,
					beforeEnter: async function (to, from, next) {
						try {
							await mediator.hideContent();
							await mediator.coaching.getSchoolSummary();
							await mediator.coaching.getSchoolProgress();
							await mediator.coaching.getSchoolLanguagesSummary();
							await mediator.coaching.getSchoolLanguagesProgress();
							await Store.dispatch('activeMenu', to.path);
							next();
						} catch (error) {
							await mediator.showContent();
							next({
								path: `/login?error=${helpers.apiErrorMessages.getHumanErrorMessage(error)}`
							});
						}
					}
				},
				{
					path: 'progress/:isoCode',
					component: LanguagesProgress,
					props: true,
					beforeEnter: async function (to, from, next) {
						try {
							await mediator.hideContent();
							await mediator.coaching.getSchoolLanguagesSummary();
							await mediator.coaching.getSchoolLanguagesProgress();
							await Store.dispatch('activeMenu', to.path);
							next();
						} catch (error) {
							await mediator.showContent();
							next({
								path: `/login?error=${helpers.apiErrorMessages.getHumanErrorMessage(error)}`
							});
						}
					}
				},
				{
					path: 'progress/:isoCode/categories',
					component: LanguagesCategoriesProgress,
					props: true,
					beforeEnter: async function (to, from, next) {
						try {
							await mediator.hideContent();
							await mediator.coaching.getSchoolLanguagesSummary();
							await mediator.coaching.getSchoolLanguagesProgress();
							await Store.dispatch('activeMenu', to.path);
							next();
						} catch (error) {
							await mediator.showContent();
							next({
								path: `/login?error=${helpers.apiErrorMessages.getHumanErrorMessage(error)}`
							});
						}
					}
				},
				{
					path: 'progress/:isoCode/categories/:categoryId',
					component: LanguagesCategoryProgress,
					props: true,
					beforeEnter: async function (to, from, next) {
						try {
							await mediator.hideContent();
							await mediator.coaching.getSchoolLanguagesSummary();
							await mediator.coaching.getSchoolLanguagesProgress();
							await Store.dispatch('activeMenu', to.path);
							next();
						} catch (error) {
							await mediator.showContent();
							next({
								path: `/login?error=${helpers.apiErrorMessages.getHumanErrorMessage(error)}`
							});
						}
					}
				}
			]
		},
		{
			path: '/coaching/academicLevels',
			component: AcademicLevels,
			meta: {allowedRoles: [ANY_ROLE]},
			children: [
				{
					path: '/',
					redirect: `list`
				},
				{
					path: 'list',
					component: AcademicLevelsList,
					beforeEnter: async function (to, from, next) {
						try {
							await mediator.hideContent();
							await mediator.coaching.getSchoolSummary();
							await mediator.coaching.getSchoolAcademicLevelsSummary();
							await Store.dispatch('activeMenu', to.path);
							next();
						} catch (error) {
							await mediator.showContent();
							next({
								path: `/login?error=${helpers.apiErrorMessages.getHumanErrorMessage(error)}`
							});
						}
					}
				},
				{
					path: 'summary/:academicLevelId',
					component: AcademicLevelsSummary,
					props: true,
					beforeEnter: async function (to, from, next) {
						try {
							await mediator.hideContent();
							await mediator.coaching.getSchoolAcademicLevelsSummary();
							await Store.dispatch('activeMenu', to.path);
							next();
						} catch (error) {
							await mediator.showContent();
							next({
								path: `/login?error=${helpers.apiErrorMessages.getHumanErrorMessage(error)}`
							});
						}
					}
				},
				{
					path: 'progress',
					component: AcademicLevelsGeneralProgress,
					props: true,
					beforeEnter: async function (to, from, next) {
						try {
							await mediator.hideContent();
							await mediator.coaching.getSchoolSummary();
							await mediator.coaching.getSchoolProgress();
							await mediator.coaching.getSchoolAcademicLevelsSummary();
							await mediator.coaching.getSchoolAcademicLevelsProgress();
							await Store.dispatch('activeMenu', to.path);
							next();
						} catch (error) {
							await mediator.showContent();
							next({
								path: `/login?error=${helpers.apiErrorMessages.getHumanErrorMessage(error)}`
							});
						}
					}
				},
				{
					path: 'progress/:academicLevelId',
					component: AcademicLevelsProgress,
					props: true,
					beforeEnter: async function (to, from, next) {
						try {
							await mediator.hideContent();
							await mediator.coaching.getSchoolAcademicLevelsSummary();
							await mediator.coaching.getSchoolAcademicLevelsProgress();
							await Store.dispatch('activeMenu', to.path);
							next();
						} catch (error) {
							await mediator.showContent();
							next({
								path: `/login?error=${helpers.apiErrorMessages.getHumanErrorMessage(error)}`
							});
						}
					}
				},
				{
					path: 'progress/:academicLevelId/categories',
					component: AcademicLevelsCategoriesProgress,
					props: true,
					beforeEnter: async function (to, from, next) {
						try {
							await mediator.hideContent();
							await mediator.coaching.getSchoolAcademicLevelsSummary();
							await mediator.coaching.getSchoolAcademicLevelsProgress();
							await Store.dispatch('activeMenu', to.path);
							next();
						} catch (error) {
							await mediator.showContent();
							next({
								path: `/login?error=${helpers.apiErrorMessages.getHumanErrorMessage(error)}`
							});
						}
					}
				},
				{
					path: 'progress/:academicLevelId/categories/:categoryId',
					component: AcademicLevelsCategoryProgress,
					props: true,
					beforeEnter: async function (to, from, next) {
						try {
							await mediator.hideContent();
							await mediator.coaching.getSchoolAcademicLevelsSummary();
							await mediator.coaching.getSchoolAcademicLevelsProgress();
							await Store.dispatch('activeMenu', to.path);
							next();
						} catch (error) {
							await mediator.showContent();
							next({
								path: `/login?error=${helpers.apiErrorMessages.getHumanErrorMessage(error)}`
							});
						}
					}
				}
			]
		},
		{
			path: '/coaching/admin',
			component: Admin,
			meta: {allowedRoles: ['SUPER-ADMIN', 'ADMINISTRATION', 'COACHING', 'EXECUTIVE', 'CUSTOMER-SERVICE']},
			children: [
				{
					path: '/',
					redirect: `schools`
				},
				{
					path: 'schools',
					component: AdminSchools,
					beforeEnter: async function (to, from, next) {
						try {
							await mediator.hideContent();
							await mediator.coaching.getSchoolSummary();
							await mediator.coaching.getAdminSchools();
							await Store.dispatch('activeMenu', to.path);
							next();
						} catch (error) {
							await mediator.showContent();
							next({
								path: `/login?error=${helpers.apiErrorMessages.getHumanErrorMessage(error)}`
							});
						}
					}
				},
				{
					path: 'schools/:schoolId/syntheses',
					component: SchoolAllSyntheses,
					props: true,
					beforeEnter: async function (to, from, next) {
						try {
							await mediator.hideContent();
							await mediator.coaching.getTrainingTalks();
							await mediator.coaching.getSchoolSummary();
							await mediator.coaching.getAdminSchools();
							await mediator.coaching.getAdminSchoolHistory(to.params.schoolId);
							await Store.dispatch('activeMenu', to.path);
							next();
						} catch (error) {
							await mediator.showContent();
							next({
								path: `/login?error=${helpers.apiErrorMessages.getHumanErrorMessage(error)}`
							});
						}
					}
				},
				{
					path: 'schools/:schoolId/syntheses/:synthesisTypeId',
					component: SchoolSyntheses,
					props: true,
					beforeEnter: async function (to, from, next) {
						try {
							await mediator.hideContent();
							await mediator.coaching.getTrainingTalks();
							await mediator.coaching.getSchoolSummary();
							await mediator.coaching.getAdminSchools();
							await mediator.coaching.getAdminSchoolHistoryByTypeId(to.params.schoolId, to.params.synthesisTypeId);
							await Store.dispatch('activeMenu', to.path);
							next();
						} catch (error) {
							await mediator.showContent();
							next({
								path: `/login?error=${helpers.apiErrorMessages.getHumanErrorMessage(error)}`
							});
						}
					}
				},
				{
					path: 'schools/:schoolId/issues',
					component: SchoolIssues,
					props: true,
					beforeEnter: async function (to, from, next) {
						try {
							await mediator.hideContent();
							await mediator.coaching.getSchoolSummary();
							await mediator.coaching.getAdminSchools();
							await mediator.coaching.getAdminSchoolHistoryByTypeId(to.params.schoolId, 4);
							await Store.dispatch('activeMenu', to.path);
							next();
						} catch (error) {
							await mediator.showContent();
							next({
								path: `/login?error=${helpers.apiErrorMessages.getHumanErrorMessage(error)}`
							});
						}
					}
				},
				{
					path: 'summary',
					component: AdminSummary,
					beforeEnter: async function (to, from, next) {
						try {
							await mediator.hideContent();
							await mediator.coaching.getSchoolSummary();
							await mediator.coaching.getSummarySchools();
							await Store.dispatch('activeMenu', to.path);
							next();
						} catch (error) {
							await mediator.showContent();
							next({
								path: `/login?error=${helpers.apiErrorMessages.getHumanErrorMessage(error)}`
							});
						}
					}
				},
				{
					path: 'syntheses/:synthesisTypeId',
					component: Syntheses,
					props: true,
					beforeEnter: async function (to, from, next) {
						try {
							await mediator.hideContent();
							await mediator.coaching.getTrainingTalks();
							await mediator.coaching.getSchoolSummary();
							await mediator.coaching.getHistoryByTypeId(to.params.synthesisTypeId);
							await Store.dispatch('activeMenu', to.path);
							next();
						} catch (error) {
							await mediator.showContent();
							next({
								path: `/login?error=${helpers.apiErrorMessages.getHumanErrorMessage(error)}`
							});
						}
					}
				},
				{
					path: 'syntheses-report/:synthesisTypeId',
					component: SynthesesReport,
					props: true,
					beforeEnter: async function (to, from, next) {
						try {
							await mediator.hideContent();
							await mediator.coaching.getTrainingTalks();
							await mediator.coaching.getSchoolSummary();
							await mediator.coaching.getSynthesesReportByTypeId(to.params.synthesisTypeId);
							await Store.dispatch('activeMenu', to.path);
							next();
						} catch (error) {
							await mediator.showContent();
							next({
								path: `/login?error=${helpers.apiErrorMessages.getHumanErrorMessage(error)}`
							});
						}
					}
				},
				{
					path: 'syntheses-dashboard/:synthesisTypeId',
					component: SynthesesDashboard,
					props: true,
					beforeEnter: async function (to, from, next) {
						try {
							await mediator.hideContent();
							await mediator.coaching.getSchoolSummary();
							await mediator.coaching.getSynthesesDashboardByTypeId(to.params.synthesisTypeId);
							await Store.dispatch('activeMenu', to.path);
							next();
						} catch (error) {
							await mediator.showContent();
							next({
								path: `/login?error=${helpers.apiErrorMessages.getHumanErrorMessage(error)}`
							});
						}
					}
				},
				{
					path: 'issues',
					component: Issues,
					props: true,
					beforeEnter: async function (to, from, next) {
						try {
							await mediator.hideContent();
							await mediator.coaching.getSchoolSummary();
							await mediator.coaching.getHistoryByTypeId(4);
							await Store.dispatch('activeMenu', to.path);
							next();
						} catch (error) {
							await mediator.showContent();
							next({
								path: `/login?error=${helpers.apiErrorMessages.getHumanErrorMessage(error)}`
							});
						}
					}
				},
				{
					path: 'visit-closure/:visitClosureId',
					component: VisitClosureDetail,
					props: true,
					beforeEnter: async function (to, from, next) {
						try {
							await mediator.hideContent();
							await mediator.coaching.getSchoolSummary();
							await mediator.coaching.getSynthesis(to.params.visitClosureId);
							await Store.dispatch('activeMenu', to.path);
							next();
						} catch (error) {
							await mediator.showContent();
							next({
								path: `/login?error=${helpers.apiErrorMessages.getHumanErrorMessage(error)}`
							});
						}
					}
				},
				{
					path: 'diagnostic/:diagnosticId',
					component: DiagnosticDetail,
					props: true,
					beforeEnter: async function (to, from, next) {
						try {
							await mediator.hideContent();
							await mediator.coaching.getSchoolSummary();
							await mediator.coaching.getSynthesis(to.params.diagnosticId);
							await Store.dispatch('activeMenu', to.path);
							next();
						} catch (error) {
							await mediator.showContent();
							next({
								path: `/login?error=${helpers.apiErrorMessages.getHumanErrorMessage(error)}`
							});
						}
					}
				},
				{
					path: 'indicator/:indicatorId',
					component: IndicatorDetail,
					props: true,
					beforeEnter: async function (to, from, next) {
						try {
							await mediator.hideContent();
							await mediator.coaching.getSchoolSummary();
							await mediator.coaching.getSynthesis(to.params.indicatorId);
							await Store.dispatch('activeMenu', to.path);
							next();
						} catch (error) {
							await mediator.showContent();
							next({
								path: `/login?error=${helpers.apiErrorMessages.getHumanErrorMessage(error)}`
							});
						}
					}
				},
				{
					path: 'training/:trainingId',
					component: TrainingDetail,
					props: true,
					beforeEnter: async function (to, from, next) {
						try {
							await mediator.hideContent();
							await mediator.coaching.getTrainingTalks();
							await mediator.coaching.getSchoolSummary();
							await mediator.coaching.getSynthesis(to.params.trainingId);
							await Store.dispatch('activeMenu', to.path);
							next();
						} catch (error) {
							await mediator.showContent();
							next({
								path: `/login?error=${helpers.apiErrorMessages.getHumanErrorMessage(error)}`
							});
						}
					}
				},
				{
					path: 'issue/:issueId',
					component: IssueDetail,
					props: true,
					beforeEnter: async function (to, from, next) {
						try {
							await mediator.hideContent();
							await mediator.coaching.getSchoolSummary();
							await mediator.coaching.getIssue(to.params.issueId);
							await Store.dispatch('activeMenu', to.path);
							next();
						} catch (error) {
							await mediator.showContent();
							next({
								path: `/login?error=${helpers.apiErrorMessages.getHumanErrorMessage(error)}`
							});
						}
					}
				},
				{
					path: 'evaluation/:evaluationId',
					component: EvaluationDetail,
					props: true,
					beforeEnter: async function (to, from, next) {
						try {
							await mediator.hideContent();
							await mediator.coaching.getSchoolSummary();
							await mediator.coaching.getEvaluation(to.params.evaluationId);
							await Store.dispatch('activeMenu', to.path);
							next();
						} catch (error) {
							await mediator.showContent();
							next({
								path: `/login?error=${helpers.apiErrorMessages.getHumanErrorMessage(error)}`
							});
						}
					}
				},
				{
					path: 'schools/:schoolId/visit-closure/:visitClosureId',
					component: VisitClosureDetail,
					props: true,
					beforeEnter: async function (to, from, next) {
						try {
							await mediator.hideContent();
							await mediator.coaching.getSchoolSummary();
							await mediator.coaching.getAdminSchools();
							await mediator.coaching.getSynthesis(to.params.visitClosureId);
							await Store.dispatch('activeMenu', to.path);
							next();
						} catch (error) {
							await mediator.showContent();
							next({
								path: `/login?error=${helpers.apiErrorMessages.getHumanErrorMessage(error)}`
							});
						}
					}
				},
				{
					path: 'schools/:schoolId/diagnostic/:diagnosticId',
					component: DiagnosticDetail,
					props: true,
					beforeEnter: async function (to, from, next) {
						try {
							await mediator.hideContent();
							await mediator.coaching.getSchoolSummary();
							await mediator.coaching.getAdminSchools();
							await mediator.coaching.getSynthesis(to.params.diagnosticId);
							await Store.dispatch('activeMenu', to.path);
							next();
						} catch (error) {
							await mediator.showContent();
							next({
								path: `/login?error=${helpers.apiErrorMessages.getHumanErrorMessage(error)}`
							});
						}
					}
				},
				{
					path: 'schools/:schoolId/training/:trainingId',
					component: TrainingDetail,
					props: true,
					beforeEnter: async function (to, from, next) {
						try {
							await mediator.hideContent();
							await mediator.coaching.getSchoolSummary();
							await mediator.coaching.getAdminSchools();
							await mediator.coaching.getSynthesis(to.params.trainingId);
							await Store.dispatch('activeMenu', to.path);
							next();
						} catch (error) {
							await mediator.showContent();
							next({
								path: `/login?error=${helpers.apiErrorMessages.getHumanErrorMessage(error)}`
							});
						}
					}
				},
				{
					path: 'schools/:schoolId/issue/:issueId',
					component: IssueDetail,
					props: true,
					beforeEnter: async function (to, from, next) {
						try {
							await mediator.hideContent();
							await mediator.coaching.getSchoolSummary();
							await mediator.coaching.getAdminSchools();
							await mediator.coaching.getIssue(to.params.issueId);
							await Store.dispatch('activeMenu', to.path);
							next();
						} catch (error) {
							await mediator.showContent();
							next({
								path: `/login?error=${helpers.apiErrorMessages.getHumanErrorMessage(error)}`
							});
						}
					}
				},
				{
					path: 'schools/:schoolId/evaluation/:evaluationId',
					component: EvaluationDetail,
					props: true,
					beforeEnter: async function (to, from, next) {
						try {
							await mediator.hideContent();
							await mediator.coaching.getSchoolSummary();
							await mediator.coaching.getAdminSchools();
							await mediator.coaching.getEvaluation(to.params.evaluationId);
							await Store.dispatch('activeMenu', to.path);
							next();
						} catch (error) {
							await mediator.showContent();
							next({
								path: `/login?error=${helpers.apiErrorMessages.getHumanErrorMessage(error)}`
							});
						}
					}
				}
			]
		},
		{
			path: '/coaching/schools',
			component: Schools,
			meta: {allowedRoles: [ANY_ROLE]},
			children: [
				{
					path: '/',
					redirect: `list`
				},
				{
					path: 'list',
					component: SchoolsList,
					beforeEnter: async function (to, from, next) {
						try {
							await mediator.hideContent();
							await mediator.coaching.getSchools();
							next();
						} catch (error) {
							await mediator.showContent();
							next({
								path: `/login?error=${helpers.apiErrorMessages.getHumanErrorMessage(error)}`
							});
						}
					}
				}
			]
		},
		{
			path: '/login',
			component: Login,
			props: (route) => ({error: route.query.error})
		},
		{
			path: '*',
			component: NoRoute
		}
	]
});

router.beforeEach(async function (to, from, next) {
	Dom.setTitle(to.path, Store.state.persistent.appName);
	const canEnter = await checkPermissions(to);

	if (canEnter) {
		console.log('can enter');
		next();
	} else {
		console.log('cannot enter');
		next({
			path: '/login'
		});
	}
});

async function checkPermissions (routeToCheck) {

	for (var i = 0; i < routeToCheck.matched.length; i++) {

		const route = routeToCheck.matched[i];

		if (route.meta && route.meta.allowedRoles) {

			try {
				const result = await Auth.authenticate();
				if (!result) return false;
			} catch (error) {
				return false;
			}

			const routeRoles = route.meta.allowedRoles;

			if (routeRoles.includes(ANY_ROLE)) {
				return true;
			} else if (!Permissions.compareRoles(routeRoles, Auth.getDecodedToken().scope)) {
				return false;
			}
		}
	}

	return true;
}

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js